import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import Form from 'antd/es/form/Form';
import styled from 'styled-components';

export const StepContentForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  overflow-y: visible;
  padding-block: ${({ theme }) => theme.spacing.md}px;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding-inline: ${({ theme }) => theme.spacing.xl}px;

  ${media.l`
    overflow-y: visible;
    height: 100%;
    padding-inline: ${({ theme }) => theme.spacing.sm + theme.spacing.xs}px;
    padding-block-end: ${({ theme }) => theme.spacing.md}px;
    padding-block-start: 0px;
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: flex-start;

  > * {
    margin: auto 0;
  }
`;

export const WrapperContainer = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  margin: 0;
`;
